import { z } from "zod";

const getConfigDeductionSlaConfigsSchema = z.object({
  search: z.string().nullable().optional(),
  page_number: z.number().int().min(1),
  page_size: z.number().int().min(1).max(100),
});

const updateConfigDeductionSlaConfigSchema = z.object({
  id: z.number().int().positive(),
  configValue: z.number(),
  description: z.string().nullable().optional(),
});

export class GetConfigDeductionSlaConfigsDTO {
  readonly search: string | null;
  readonly page_number: number;
  readonly page_size: number;

  constructor(params: {
    search?: string | null;
    page_number: number;
    page_size: number;
  }) {
    const parsed = getConfigDeductionSlaConfigsSchema.parse({
      search: params.search ?? null,
      page_number: params.page_number,
      page_size: params.page_size,
    });
    this.search = parsed.search ?? null;
    this.page_number = parsed.page_number;
    this.page_size = parsed.page_size;
  }
}

export class UpdateConfigDeductionSlaConfigDTO {
  readonly id: number;
  readonly configValue: number;
  readonly description: string | null;

  constructor(params: {
    id: number;
    configValue: number;
    description?: string | null;
  }) {
    const parsed = updateConfigDeductionSlaConfigSchema.parse(params);
    this.id = parsed.id;
    this.configValue = parsed.configValue;
    this.description = parsed.description ?? null;
  }
}
